import { MoreProvider } from './More/MoreContext';
import {
  LayoutOrderContainer,
  LayoutReviewBodyContent,
  LayoutStickySection,
  LayoutTabSection,
} from './orders/_layouts/LayoutOrderContainer';

import AlertDialog from '@/components/dashboard/alert-dialog';
import CategorySelect from './More/CategorySelect';
import FAQContainer from './More/FAQContainer';
import MemberShipContainer from './More/MemberShipContainer';
import { useMore } from './More/MoreContext';
import SupportContainer from './More/SupportContainer';
import TabSection from './More/TabSection';

const MorePage = () => {
  return (
    <MoreProvider>
      <AlertDialog />
      <MoreContent />
    </MoreProvider>
  );
};

export default MorePage;

const MoreContent = () => {
  const { currentTab } = useMore();

  const renderTabContent = () => {
    switch (currentTab) {
      case 'faq':
        return <FAQContainer />;
      case 'membership':
        return <MemberShipContainer />;
      case 'support':
        return <SupportContainer />;
      default:
        return <MemberShipContainer />;
    }
  };
  return (
    <LayoutOrderContainer>
      <div className="sticky top-0 z-10 bg-gr-50">
        <LayoutTabSection>
          <TabSection />
        </LayoutTabSection>
        <LayoutStickySection className="max-w-full bg-gr-50/90 pb-[0px] pr-[60px]">
          <CategorySelect />
        </LayoutStickySection>
      </div>
      <LayoutReviewBodyContent>
        {renderTabContent()}

        {/* 여기에 추가 기능 컴포넌트들을 넣을 수 있습니다 */}
      </LayoutReviewBodyContent>
    </LayoutOrderContainer>
  );
};
